<template>
  <div class="home">
    <!-- 公告 -->
    <!-- 轮播图 参数根据封装参数传参-->
    <!-- <Banner :images="carouselImages"></Banner> -->
    <!-- 热点要闻 -->
    <div class="hot wp75">
      <div class="hot-content">
        <div class="hot-center">
          <div class="hot-center-left">
            <div class="left-title">{{ currentItem.chineseTitle }}</div>
            <div class="detail-little-title blue-text">
              <p>{{ currentItem.createTime }}</p>
              <p>来源：{{ currentItem.newsSource ? currentItem.newsSource : '-' }}</p>
              <GsShare
                variant="link"
                button-text="分享链接"
                :id="currentItem.id"
                :title="currentItem.chineseTitle"
                :summary="currentItem.digest"
                :image="prodUrl + (currentItem.homePicture || '')"
              />
            </div>
            <div class="mt10 content-new color6" style v-html="currentItem.content"></div>
            <div class="color9">
              <div class="text-content">
                <div class="text-content-right border" v-if="currentItem.url">
                  <a :href="currentItem.url" target="_blank" rel="noopener noreferrer" class="url url-img">
                    <img src="@/assets/images/link.png" class="link" />查看原文
                  </a>
                </div>
              </div>
            </div>
            <el-divider />
            <div style="margin-left:20px;" class="color9">
              <div class="text-content">
                <div
                  class="text-content-left"
                  v-if="currentItem.rangeTypeName"
                >{{ currentItem.rangeTypeName }}</div>
                <div
                  class="text-content-middle"
                  v-if="currentItem.areaName"
                >{{ currentItem.areaName }}</div>
              </div>
            </div>
          </div>
          <div class="hot-center-right">
            <twentyFourNew />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "../Home/components/carousel/index";
import carousel1 from "../Home/components/carousel/index1";
import Banner from "../Home/components/Banner";
import newsDetail from "../../components/NewsDetail";
import userDetail from "../../components/UserDetail";
import Interview from "@/components/Interview";
import twentyFourNew from "@/components/24HNew";
import LiveInfo from "../../components/LiveInfo";
import ZcFileInfo from "@/components/ZcFileInfo";
import { getNewsList, getArticleDetail } from "@/api/api";
import GsShare from "@/components/GsShare/index.vue";
import { routeId } from "@/router/paths";

/**
 * 资讯各类别可以有自己的配图（category_images: { "1": "/xx.png" }，后台按类别比例上传）。
 * 详情页按这条记录的第一个类别取图，取不到就沿用新闻首页图。
 */
function pickCategoryPicture(item) {
  const raw = item && item.categoryImages
  if (!raw || typeof raw !== 'string' || raw.charAt(0) !== '{') return ''
  let map = null
  try {
    map = JSON.parse(raw)
  } catch (e) {
    return ''
  }
  if (!map || typeof map !== 'object') return ''
  let cats = item.type
  if (typeof cats === 'string' && cats.charAt(0) === '[') {
    try {
      cats = JSON.parse(cats)
    } catch (e) {
      cats = []
    }
  }
  const list = Array.isArray(cats) ? cats : String(cats || '').split(',')
  for (const value of list) {
    const key = String(value).trim()
    if (key && map[key]) return map[key]
  }
  const first = Object.keys(map).find((key) => map[key])
  return first ? map[first] : ''
}

export default {
  data() {
    return {
      carouselImages: [],
      twentyFourNewList: [],
      hostNewList: [],
      newsDetailData: [],
      newsDetailData2: [],
      userDetailData: [],
      currentItem: {},
      title: (this.$route.meta && this.$route.meta.title) || '',
      prodUrl: "https://shujuzichan.com/xwzx"
    };
  },
  components: {
    twentyFourNew,
    carousel,
    carousel1,
    Banner,
    newsDetail,
    LiveInfo,
    userDetail,
    Interview,
    ZcFileInfo,
    GsShare
  },
  created() {
    this.getSyLbNewList();
    // this.getHostNewList();
    this.getTwentyFourNewList();
    // this.getNewList();
    // this.getUserData();
  },
  watch: {
    "$route.params.id": {
      deep: true,
      immediate: true,
      handler() {
        const id = routeId(this.$route)
        if (id) this.newsDetail(id)
      }
    }
  },
  methods: {
    // x详情数据
    newsDetail(id) {
      getArticleDetail(id).then(res => {
        const data = res.data || {};
        // 各类别有各自尺寸的配图时，优先用当前类别的图
        const pic = pickCategoryPicture(data);
        this.currentItem = pic ? { ...data, homePicture: pic } : data;
      });
    },
    getUserData() {
      const formData = {};
      formData["pageNum"] = 1;
      formData["pageSize"] = 10;
      formData["type"] = 3;
      formData["whetherPublish"]='1';
      getNewsList(formData).then(response => {
        this.userDetailData = response.rows;
      });
    },

    getNewList() {
      const formData = {};
      formData["pageNum"] = 1;
      formData["pageSize"] = 10;
      formData["type"] = 2;
      formData["whetherPublish"]='1';
      getNewsList(formData).then(response => {
        this.newsDetailData = response.rows;
      });
      formData["pageNum"] = 2;
      formData["whetherPublish"]='1';
      getNewsList(formData).then(response => {
        this.newsDetailData2 = response.rows;
      });
    },
    getSyLbNewList() {
      const formData = {};
      formData["pageNum"] = 1;
      formData["pageSize"] = 5;
      formData["newest"] = 0;
      formData["whetherPublish"]='1';
      getNewsList(formData).then(response => {
        this.carouselImages = response.rows;
      });
    },
    getHostNewList() {
      const formData = {};
      formData["pageNum"] = 1;
      formData["pageSize"] = 5;
      formData["newest"] = 3;
      formData["whetherPublish"]='1';
      getNewsList(formData).then(response => {
        this.hostNewList = response.rows;
      });
    },
    getTwentyFourNewList() {
      const formData = {};
      formData["pageNum"] = 1;
      formData["pageSize"] = 10;
      formData["type"] = 1;
      formData["whetherPublish"]='1';
      getNewsList(formData).then(response => {
        this.twentyFourNewList = response.rows;
      });
    }
  }
};
</script>

<style scoped lang="css">
.hot {
  background: #fff;
  margin-top: 10px;
  height: 100%;
}

.hot-center {
  /* height: 400px; */
  display: flex;
  align-items: center;
  align-items: flex-start;
}
.hot-center-left {
  width: 67%;
  height: 100%;
  padding: 15px;
}
.left-title {
  margin: 20px auto;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
}
.detail-little-title {
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  font-size: 12px;
  .el-button--text {
    color: #0165ff;
    font-weight: 400;
  }
}
.content-new {
  text-indent: 25px;
  line-height: 30px;
}
::v-deep .content-new img {
  width: calc(100% - 50px) !important;
  height: 100% !important;
}
.el-divider--horizontal {
  margin: 15px 0;
}
.hot-center-left img {
  width: 100%;
  height: 100%;
}
.hot-center-right {
  width: 33%;
  height: 100%;
  margin-left: 10px;
  overflow: auto;
}

.detail-box img {
  width: 100%;
  height: 150px;
  border-radius: 6px 6px 0 0;
}
.url:hover {
  color: #0165ff;
  cursor: pointer;
}
img.link {
  width: 13px;
  height: 13px;
}
.border {
  border: 2px solid #d2d2d4;
  text-align: center;
  padding: 2px 4px;
}

.text-content {
  display: flex;
  align-items: center;
}
.text-content {
  margin-left: 10px;
}
.text-content-left {
  margin-left: 5px;
}
.text-content-middle {
  margin-left: 5px;
}
.text-content-right {
  margin-left: 5px;
}
@media (max-width: 960px) {
  .hot.wp75 {
    width: 100%;
    max-width: 100%;
    padding: 0;
  }
  .hot-center {
    flex-direction: column;
  }
  .hot-center-left,
  .hot-center-right {
    width: 100%;
    margin-left: 0;
    padding: 8px 0;
  }
  .hot-center-right {
    margin-top: 12px;
  }
  .left-title {
    margin: 8px 0 12px;
    font-size: 18px;
    line-height: 26px;
    text-align: left;
  }
  .detail-little-title {
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 0 8px;
  }
  .content-new {
    text-indent: 0;
    line-height: 26px;
    overflow-wrap: anywhere;
  }
  :deep(.content-new img),
  .hot-center-left img {
    width: 100% !important;
    max-width: 100%;
    height: auto !important;
  }
  :deep(.el-dialog) {
    width: 92% !important;
    max-width: 360px;
    margin: 12vh auto 0;
  }
}
</style>